module.exports = __webpack_public_path__ + "static/media/bbt.2a6e0751.svg";